import styles from "../RereservationCompletePageV2.module.scss"

const SubmittedMessage = () => {
	return (
		<div className={styles.email_submitted_message}>
			<p>✓ メールアドレスを登録しました</p>
			<p className={styles.email_note}>
				予約日の前日にリマインドをお送りします
			</p>
			<p className={styles.email_note}>
				登録されたメールアドレスに確認メールが送付されていますので、ご確認ください。
			</p>
		</div>
	)
}

export default SubmittedMessage
